import { render, staticRenderFns } from "./RecruitmentNotesModal.vue?vue&type=template&id=b9ba2bfc&scoped=true&"
import script from "./RecruitmentNotesModal.vue?vue&type=script&lang=js&"
export * from "./RecruitmentNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentNotesModal.vue?vue&type=style&index=0&id=b9ba2bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba2bfc",
  null
  
)

export default component.exports